<template>
  <article class="monthly-print-detail">
    <h2 style="text-align: center; margin-bottom: 20px">每月食品安全调度会议记录</h2>
    <a-descriptions bordered :column="2">
      <a-descriptions-item label="会议名称">
        {{ form?.others?.meeting_name || '-' }}
      </a-descriptions-item>
      <a-descriptions-item label="主持人">
        {{ form?.others?.host || '-' }}
      </a-descriptions-item>
      <a-descriptions-item label="会议日期">
        {{ formatDate(form?.others?.meeting_date) }}
      </a-descriptions-item>
      <a-descriptions-item label="负责人">
        {{ form?.others?.head || '-' }}
      </a-descriptions-item>
      <a-descriptions-item label="会议地点" :span="2">
        <div style="white-space: pre-wrap">{{ form?.others?.meeting_location || '-' }}</div>
      </a-descriptions-item>
      <a-descriptions-item label="出席人员" :span="2">
        {{ form?.others?.attendance || '-' }}
      </a-descriptions-item>
      <a-descriptions-item label="会议内容记录" :span="2">
        <div style="white-space: pre-wrap">{{ form?.others?.meeting_record || '-' }}</div>
      </a-descriptions-item>
      <a-descriptions-item label="下个月食品安全管理重点工作调度计划" :span="2">
        <div style="white-space: pre-wrap">{{ form?.others?.months_plan || '-' }}</div>
      </a-descriptions-item>
      <a-descriptions-item label="汇报人">
        {{ form?.others?.reported_by || '-' }}
      </a-descriptions-item>
    </a-descriptions>
  </article>
</template>

<script>
import moment from 'moment';

export default {
  name: "PrintDetail",
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '-';
      return moment(date).format('YYYY-MM-DD');
    }
  }
};
</script>

<style lang="less" scoped>
.monthly-print-detail {
  padding: 20px;
  
  :deep(.ant-descriptions-item-label) {
    font-weight: bold;
    background-color: #fafafa;
  }
  
  :deep(.ant-descriptions-item-content) {
    min-height: 32px;
  }
}
</style>
